import {
  GET_SUBSCRIBER_BASE_REPORT,
} from 'redux/admin-constants';

const initialState = {
  subscriberReportData: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SUBSCRIBER_BASE_REPORT: {
      return {
        ...state,
        subscriberReportData: payload,
      };
    }

    default:
      return state;
  }
};
export default reducer;